/**
 * <flash-sale-banner> — PDP flash-sale banner that reacts to variant selection.
 *
 * The flash-sale end date is a product-level metafield, but a flash sale often
 * applies to only ONE variant. The reliable signal for "this variant is on the
 * flash sale" is its Compare-at price (compare_at_price > price) — generic
 * markdowns don't set compare-at, so they won't trigger this banner. The banner
 * is therefore shown only while the selected variant has compare_at > price, and
 * hidden for full-price variants. Initial (server-rendered) state already
 * reflects the first/selected variant, so there's no flicker on load.
 */
if (!customElements.get('flash-sale-banner')) {
  class FlashSaleBanner extends HTMLElement {
    connectedCallback() {
      this.saveEl = this.querySelector('.fs-pdp__save');
      this.saveTemplate = this.dataset.saveTemplate || 'Save __PCT__%';
      this._onVariantChange = this.handleVariantChange.bind(this);
      document.addEventListener('on:variant:change', this._onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('on:variant:change', this._onVariantChange);
    }

    handleVariantChange(evt) {
      const variant = evt.detail && evt.detail.variant;
      if (!variant) return;

      // Shopify variant JSON prices are integers in cents; compare_at may be null.
      const price = Number(variant.price) || 0;
      const compareAt = Number(variant.compare_at_price) || 0;
      let pct = 0;
      if (compareAt > price && compareAt > 0) {
        pct = Math.round(((compareAt - price) / compareAt) * 100);
      }
      this.apply(pct);
    }

    apply(pct) {
      const onSale = pct > 0;
      // Full-price variants hide the banner; the flash variant's OPTION BUTTON
      // carries a "Flash Sale" corner badge instead (variant-picker.liquid).
      this.hidden = !onSale;

      if (this.saveEl) {
        this.saveEl.hidden = !onSale;
        if (onSale) this.saveEl.textContent = this.saveTemplate.replace('__PCT__', pct);
      }
    }
  }

  customElements.define('flash-sale-banner', FlashSaleBanner);
}
